/**
 * Excel 导入限制校验工具
 *
 * 满足属性 15：acceptsImport(size, rows) 等价于 size ≤ MAX && rows ≤ MAX
 *
 * 详见 Requirement 7.3 / 7.4
 */

/** 上传文件大小上限（20 MB） */
export const UPLOAD_MAX_MB = 20;
export const UPLOAD_MAX_BYTES = UPLOAD_MAX_MB * 1024 * 1024;

/** 上传行数上限 */
export const UPLOAD_MAX_ROWS = 10_000;

/**
 * 是否接受导入
 *
 * @param sizeBytes 文件字节数
 * @param rowCount 行数
 */
export function acceptsImport(sizeBytes: number, rowCount: number): boolean {
  if (!Number.isFinite(sizeBytes) || sizeBytes < 0) return false;
  if (!Number.isFinite(rowCount) || rowCount < 0) return false;
  return sizeBytes <= UPLOAD_MAX_BYTES && rowCount <= UPLOAD_MAX_ROWS;
}
